import traderJson from "./traders.json";
import { iconsAndImages } from "../../assets/images";
import "./traderStyle.scss";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export const Traders = () => {
    useEffect(() => {
        AOS.init();
    }, []);
    return (
        <section style={{ backgroundColor: "#0F172A" }} className="py-5">
            <div className="container">
                <div className="row align-items-center gy-4">
                    <div className="col-12 col-lg-5">
                        <div className="w-100 text-center img-box" data-aos="fade-right">
                            <img
                                loading="lazy"
                                src={iconsAndImages[traderJson?.img]}
                                alt="traders"
                                className="img-fluid rounded shadow trader-img"
                            />
                        </div>
                    </div>

                    <div className="col-12 col-lg-7">
                        <div className="ps-0 ps-md-5">

                            <span className="text-yellow fw-bold d-block mb-2">
                                {traderJson?.info}
                            </span>

                            <h2
                                className="bebas-neue-regular fw-bold text-light mb-3 trader-title"
                                dangerouslySetInnerHTML={{ __html: traderJson?.mainContent }}
                            />

                            <p
                                className="text-light trader-desc"
                                dangerouslySetInnerHTML={{ __html: traderJson?.subContent }}
                            />

                            <hr className="border-secondary my-4" />

                            <div className="row text-center text-md-start">
                                {traderJson?.castlist?.map((details, index) => (
                                    <div className="col-4" key={index}>
                                        <h5 className="text-yellow bebas-neue-regular mb-1">
                                            {details?.value}
                                        </h5>
                                        <p className="text-light small mb-0">
                                            {details?.name}
                                        </p>
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};